// src/store/reducers/nguoidung.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { NGUOIDUNG } from '../constants';
import { Get } from '../../utils/httpProvider';
import { NGUOIDUNG_API } from '../../utils/apiUrl';

// ---------------------------
// Async Thunk: Lấy NguoiDung theo AccountID
// ---------------------------
export const getNguoiDungByAccountId = createAsyncThunk(
    NGUOIDUNG.GET_BY_ACCOUNT_ID,
    async (accountId, { rejectWithValue }) => {
        try {
            const response = await Get(NGUOIDUNG_API.GET_BY_ACCOUNT_ID(accountId));
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// ---------------------------
// Async Thunk: Lấy NguoiDung theo NguoiDungId (id trong bảng NguoiDung)
// ---------------------------
export const getNguoiDungById = createAsyncThunk(
    NGUOIDUNG.GET_BY_ID,
    async (id, { rejectWithValue }) => {
        try {
            if (typeof NGUOIDUNG_API.GET_BY_ID === 'function') {
                const response = await Get(NGUOIDUNG_API.GET_BY_ID(id));
                return response;
            }

            // fallback: try GET_BY_ACCOUNT_ID if GET_BY_ID not available
            const response = await Get(NGUOIDUNG_API.GET_BY_ACCOUNT_ID(id));
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// ---------------------------
// Initial State
// ---------------------------
const initialState = {
    nguoiDungItem: null,
    loading: false,
    error: null
};

// ---------------------------
// Slice
// ---------------------------
export const nguoiDungSlice = createSlice({
    name: NGUOIDUNG.NAME_SLICE,
    initialState,
    reducers: {
        clearNguoiDung: (state) => {
            state.nguoiDungItem = null;
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getNguoiDungByAccountId.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getNguoiDungByAccountId.fulfilled, (state, action) => {
                state.loading = false;
                state.nguoiDungItem = action.payload;
            })
            .addCase(getNguoiDungByAccountId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Lỗi khi lấy dữ liệu người dùng';
            })
            .addCase(getNguoiDungById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getNguoiDungById.fulfilled, (state, action) => {
                state.loading = false;
                state.nguoiDungItem = action.payload;
            })
            .addCase(getNguoiDungById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Lỗi khi lấy thông tin Người dùng theo ID';
            });
    }
});

// ---------------------------
// Exports
// ---------------------------
export const { clearNguoiDung } = nguoiDungSlice.actions;
export default nguoiDungSlice.reducer;
